import { gsap } from "gsap"
import Pin from '@/scripts/pin/Pin'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)
const CLASS_PRE = 'article-group'
export default class ArticleGroup {
    constructor(container) {
        this.$articleGroup = container
        this.$navigation = this.$articleGroup.querySelector(`.${CLASS_PRE}__navigation`)
        this.$navigationItems = this.$articleGroup.querySelectorAll(`.article-navigation__item`)
        this.$content = this.$articleGroup.querySelector(`.${CLASS_PRE}__content`)
        this.$activeNav = null
        this.pinOptions = { // Pin Options
            start: 'top-=50 top',
            end: 'bottom 80%',
            pinSpacing: false
        }

        this.init()
    }

    init() {
        this.createNavPin()
        this._addEventListener()
    }

    gotToActiveNav() {
        const $navigationList = this.$navigation.querySelector('.article-navigation__list')
        if(this.$activeNav)
            gsap.to($navigationList, {duration: 0.4, scrollTo: {
                x: this.$activeNav,
                offsetX: 15
            }})
    }

    onSectionChange(e) {
        this.$activeNav = e.detail.isActive() ? e.target : null
        this.gotToActiveNav()
    }

    createNavPin() {
        new Pin(this.$navigation, this.$articleGroup, this.pinOptions)
    }

    _addEventListener() {
        this.$navigationItems.forEach($n => $n.addEventListener('targetUpdate', (e) => this.onSectionChange(e)))
    }
}